import React from 'react';

function TechnicalSkills() {
  return (
    <div>
      <h1>Technical Skills</h1>
      <ul>
        <li>
          <b>Front End:</b> JavaScript, React.js, HTML5, CSS, Sass, Bootstrap, jQuery, AJAX
        </li>
        <li>
          <b>Back End:</b> Python, Flask, SQLAlchemy, Node.js, Express.js, Node-pg, REST API design
        </li>
        <li>
          <b>Database:</b> SQL, PostgreSQL
        </li>
        <li>
          <b>Development and Deployment:</b> Git, GitHub, Heroku
        </li>
        <li>
          <b>Testing:</b> Test Driven Development, Python unittest, Jasmine, Jest, React Testing
          Library
        </li>
      </ul>
    </div>
  );
}

export default TechnicalSkills;
